const rolesState = {
    requestingCreateRole: false,
    requestingModifyRole: false,
    requestingRemoveRole: false,
    requestingRoles: false,
    roles: undefined
};
export default rolesState;
